<template>
  <div class="index bg" v-if="loaded">
    <div class="btn-top">
      <div @click="changeBtn('going')" :class="type === 'going' ? 'btn-active' : ''">进行中</div>
      <div @click="changeBtn('waiting')" :class="type === 'waiting' ? 'btn-active' : ''">未开始</div>
      <div @click="changeBtn('ending')" :class="type === 'ending' ? 'btn-active' : ''">已结束</div>
      <div @click="changeBtn('')" :class="type === '' ? 'btn-active' : ''">全部</div>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="width100 pb100">
      <van-list v-model="loading" :finished="!hasMore" @load="getList">
        <van-cell class="van-cell1" v-for="(item, index) in lists" :key="index"
          style="background-color: rgba(255,255,255,0.7) !important;border-bottom: solid 2px rgba(170,85,0,0.1);">
          <div class="flexrow jc_start ai_start ranking-container" @click="toUrl(item.vote_id)">
            <!-- <van-image :src="item.cover" width="90" height="70" fit="cover" radius="3px"></van-image> -->
            <div class="left">
              <div class="font15 fwbolder title ">{{ item.title }}</div>
              <div class="flexrow jc_start pt2 font14">
                <span class="green">人{{ item.players || 0 }}</span>
                <span class="oriage pl10">赏{{ item.rewards || 0 }}</span>
                <span class="oriage pl10">实{{ item.rewards_top || 0 }}</span>
              </div>
              <div class="flexrow jc_start pt2 font13 color666">
                开始时间：
                <span>{{ item.start_at }}</span>
              </div>
              <div class="flexrow jc_start font13 color666">
                结束时间：
                <span>{{ item.end_at }}</span>
              </div>
              <div class="status">{{ item.status }}</div>
            </div>
          </div>
        </van-cell>
        <template #loading>
          <div class="txtMore">{{ !refresh && !refreshing && hasMore ? '下拉加载更多...' : '' }}</div>
        </template>
        <template #finished>
          <div class="txtMore">{{ !refresh && !refreshing && !hasMore ? '没有更多数据！' : '' }}</div>
        </template>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  name: 'Index',
  data() {
    return {
      loaded: false,
      lists: [],
      refreshing: false,
      refresh: false,
      loading: false,
      hasMore: true,
      page: 1,
      type: 'going'
    };
  },
  watch: {
    show: function (e) {
      if (e) {
        this.$nextTick(x => {
          this.$refs.input.focus();
        });
      }
    }
  },
  components: {
  },
  beforeMount() {
    if (this.$route.query.token) {
      this.login(this.$route.query.token);
      this.$router.push({ name: 'index' });
    }
  },
  mounted() {
    this.getList();
  },
  created() {
    history.pushState(null, null, document.URL);
    window.addEventListener('popstate', function () {
      history.pushState(null, null, document.URL);
    });
  },
  activated() {
    this.rewards = this.$api.index.rewardsGlabel;
    this.logs = this.$api.index.logsGlabel;
    this.comments = this.$api.index.commentsGlabel;
    this.polls = this.$api.index.pollsGlabel;
  },
  methods: {
    ...mapMutations(['login']),
    finishDown(e) {
      this.info.vote.to_end = e;
    },
    changeBtn(type) {
      if (type != this.type) {
        this.type = type
        this.onRefresh()
      }
    },
    onRefresh() {
      this.refresh = true;
      this.hasMore = false;
      this.page = 1;
      this.lists = []
      this.getList();
    },
    toUrl(e) {
      this.$router.push({ name: 'detail', query: { id: e } });
    },
    getList() {
      this.$api.index
        .analytics(this.page, this.type)
        .then(res => {
          console.log(res);
          setTimeout(() => {
            if (this.refreshing) {
              this.lists = [];
              this.refreshing = false;
              this.hasMore = true;
              this.page = 1;
            }
            this.loaded = true;
            this.lists = this.lists.concat(res.data);
            if (res.page.has_more) {
              this.hasMore = true;
              this.page = this.page + 1;
              this.loading = false;
              this.refresh = false;
            } else {
              this.hasMore = false;
              this.loading = false;
              this.refresh = false;
            }

          }, 1000)
        })
        .catch(err => { });
    },

  }
};
</script>

<style scoped>
.left {
  flex: 1;
  min-height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  box-sizing: border-box;
  position: relative;
}

.van-cell1 {
  background-color: none !important;
  margin-bottom: 10px;
}

.oriage {
  color: #e29804;
}

.blue {
  color: #55aaff;
}

.green {
  color: #00aa00;
}

.status {
  background-color: rgba(0, 170, 0, 0.6);
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 0 8px;
  border-radius: 3px;
  font-size: 10px;
  color: #fff;
}

.status1 {
  background-color: rgba(0, 0, 0, 0.3);
}

.title {
  color: #333333;
  font-weight: bold;
  text-align: left;
  line-height: 18px;
}

.btn-top {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  background-color: #fff;
  margin-bottom: 10px;
}

.btn-top>div {
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 13px;
  color: #333;
  margin: 10px;
}

.btn-top .btn-active {
  background-color: rgba(0, 170, 0, 0.6);
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue